import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import custom from "./plugins/custom";
import i18n from "./plugins/languages";

createApp(App)
  .use(store)
  .use(router)
  .use(vuetify)
  .use(custom)
  .use(i18n)
  .mount("#app");
